export default {
  ROWS: 'ROWS',
  COLUMNS: 'COLUMNS',
};
